<template>
  <fragment>
    <div class="flex-row justify-between align-center margin-bottom-4">
      <div class="flex-column flex-1 margin-right-4">
        <div class="invite-input-label-container">
          <span class="invite-input-label-txt">First Name</span>
        </div>
        <SACInput
          placeholder="Enter first name"
          field="firstName"
          :value="firstName"
          :change="change"
          :error="errorObj.firstNameErr"
        />
      </div>
      <div class="flex-column flex-1">
        <div class="invite-input-label-container">
          <span class="invite-input-label-txt">Last Name</span>
        </div>
        <SACInput
          placeholder="Enter last name"
          field="lastName"
          :value="lastName"
          :change="change"
          :error="errorObj.lastNameErr"
        />
      </div>
    </div>
    <div class="flex-row justify-between align-center margin-bottom-4">
      <div class="flex-column flex-1 margin-right-4">
        <div class="invite-input-label-container">
          <span class="invite-input-label-txt">Email</span>
        </div>
        <SACInput
          placeholder="Enter email"
          field="email"
          :value="email"
          :change="change"
          :error="errorObj.emailErr"
        />
      </div>
      <div class="flex-column flex-1">
        <div class="invite-input-label-container">
          <span class="invite-input-label-txt">Phone</span>
        </div>
        <SACInput
          placeholder="Enter phone"
          field="phone"
          :value="phoneNumber"
          :change="change"
          :error="errorObj.phoneErr"
        />
      </div>
    </div>
    <div
      v-if="isSmacAdmin && allPartners"
      class="ac-input-container"
    >
      <div class="invite-input-label-container">
        <span class="invite-input-label-txt">Partner</span>
      </div>
      <SACDropdown
        class="margin-bottom"
        :options="allPartners"
        :value="corpId"
        optionLabel="corporationName"
        optionValue="id"
        placeholder="Select Partner"
        searchParameter="corporationName"
        :showSearch="true"
        field="corpId"
        :change="change"
      />
    </div>
    <div
      v-if="currentAdmin.parentCorp"
      class="ac-input-container"
    >
      <div class="ac-input-header">
        Branch
      </div>
      <SACDropdown
        class="margin-bottom"
        :options="allBranches(false)"
        :value="corpId"
        placeholder="Select Branch"
        field="corpId"
        :change="change"
      />
    </div>
    <div class="ac-input-container">
      <div class="flex-row align-center just-between mt-4 mb-2">
        <div class="ac-input-header">
          Select preferred Smart Maintenance® plan. 
        </div>
        <button
          type="button"
          class="link-button"
          @click="() => toggleActionModal('sms-text-preview')"
        >
          View SMS Text Preview
        </button>
      </div>
      <SACDropdown
        class="margin-bottom"
        :options="providerPlans"
        :value="providerPlanId"
        placeholder="Select Plan"
        field="providerPlanId"
        :change="change"
        :error="errorObj.providerPlanErr"
      />
    </div>
  </fragment>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

import SACInput from '@shared/components/sac/SACInput.vue';
import SACDropdown from '@shared/components/sac/SACDropdown.vue';

export default {
  name: 'ContactInfo',
  components: {
    SACInput,
    SACDropdown,
  },
  props: {
    firstName: String,
    lastName: String,
    email: String,
    phoneNumber: String,
    corpId: Number,
    allPlans: Array,
    providerPlanId: Number,
    providerPlans: Array,
    change: Function,
    errorObj: Object,
  },
  computed: {
    ...mapState({
      currentAdmin: (state) => state.admin.current,
      allPartners: (state) => state.partner?.partners,
    }),
    ...mapGetters([
      'isSmacAdmin',
      'allBranches',
    ]),
  },
  methods: {
    toggleActionModal(view) {
      const selectedPlan = this.allPlans.find((p) => p.planId === this.providerPlanId) || {};
      this.$store.dispatch('changeCustomerValues', [{
        field: 'actionModalView',
        value: view,
      }, {
        field: 'selectedPlan',
        value: selectedPlan,
      }]);
    },
  }
};
</script>

<style lang="scss" scoped>
.link-button {
  color: $NBLUE100;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 500;
  text-decoration: underline;
}
</style>